import React, { ReactElement, useContext } from 'react';
import Head from 'next/head';
import { Nullable } from '../../models';
import { PresetsContext } from '../../contexts';
import { HeadSocialMetaModel } from './headSocialMeta.model';
import { buildTags } from './headSocialMeta.helper';

export const HeadSocialMeta = ({
  seo,
}: HeadSocialMetaModel): Nullable<ReactElement> => {
  const mediaPresets = useContext(PresetsContext)?.mediaPresets;

  return <Head>{buildTags(seo, mediaPresets)}</Head>;
};
